import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Autosuggest from 'react-autosuggest'
import Icon from '../Icon'

const includes = (a = '', b = '') => {
  return a.toLowerCase().trim().includes(b.toLowerCase().trim())
}

const noop = x => x

@observer
export default class StoreAutoComplete extends Component {

  static defaultProps = {
    exclude: [],
    onSelect: noop,
    parseFetchedSuggestions: noop
  }

  defaultGetValue = record => {
    return record.name || record.title || record.label
  }

  get getValue() {
    const { getValue=this.defaultGetValue } = this.props
    return getValue
  }

  defaultRenderSuggestion = record => {
    return this.getValue(record)
  }

  get renderSuggestion() {
    const { renderSuggestion=this.defaultRenderSuggestion } = this.props
    return renderSuggestion
  }

  defaultFetchSuggestions = value => {
    const { exclude, store } = this.props
    const suggestions = store.filter(record => {
      return includes(this.getValue(record), value) && !exclude.includes(record.id)
    })
    return Promise.resolve(suggestions)
  }

  get fetchSuggestions() {
    const { fetchSuggestions=this.defaultFetchSuggestions } = this.props
    return fetchSuggestions
  }

  defaultFetchRecordFromSuggestion = suggestion => {
    return Promise.resolve(suggestion)
  }

  get fetchRecordFromSuggestion() {
    const { fetchRecordFromSuggestion=this.defaultFetchRecordFromSuggestion } = this.props
    return fetchRecordFromSuggestion
  }

  handleFetchRequested = ({ value }) => {
    const { parseFetchedSuggestions } = this.props

    this.fetchSuggestions(value)
      .then(suggestions => parseFetchedSuggestions(suggestions, value))
      .then(suggestions => this.setState({ suggestions }))
  }

  handleClearRequested = () => {
    this.setState({ suggestions: [] })
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue, record_id: ''
    })
  }

  handleSelect = (event, { suggestion }) => {
    const { clearAfterSelect, onSelect } = this.props

    this.fetchRecordFromSuggestion(suggestion).then(record => {
      if (clearAfterSelect) {
        this.setState({ record_id: '', value: '' })
      } else {
        this.setState({ record_id: record.id })
      }
      onSelect(record)
    })
  }

  state = {
    suggestions: [],
    record_id: this.props.selected || '',
    value: ''
  }

  renderSelected() {
    const { store, name, onSelect } = this.props
    const { record_id } = this.state
    const record = store.findById(record_id)
    let contents
    if (record) {
      contents = this.getValue(record)
    } else {
      contents = 'Loading...'
      store.load(record_id).then(() => this.forceUpdate())
    }
    return (
      <div className="auto-complete-selected">
        <span className="contents">{contents}</span>
        <button onClick={() => {
          this.setState({ record_id: '', value: '' })
          onSelect()
        }}>
          <Icon icon="times" />
        </button>
        { name ? (
          <input type="hidden" name={name} value={record_id} />
        ) : null}
      </div>
    )
  }

  renderCreateNew() {
    const { onCreateNew, createNewType } = this.props
    if (onCreateNew) {
      return (
        <div className="auto-complete-create-new">
          <button type="button" onClick={onCreateNew}>Create New {createNewType}</button>
        </div>
      )
    }
  }

  renderSelector() {
    const { placeholder } = this.props
    const { suggestions, value } = this.state
    return (
      <div className="store-auto-complete">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.handleFetchRequested}
          onSuggestionsClearRequested={this.handleClearRequested}
          getSuggestionValue={this.getValue}
          renderSuggestion={this.renderSuggestion}
          onSuggestionSelected={this.handleSelect}
          highlightFirstSuggestion={true}
          shouldRenderSuggestions={() => true}
          focusInputOnSuggestionClick={false}
          inputProps={{
            placeholder,
            onChange: this.handleChange,
            value
          }} />
          {this.renderCreateNew()}
      </div>
    )
  }

  render() {
    return this.state.record_id ? this.renderSelected() : this.renderSelector()
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/StoreAutoComplete.js